import React from 'react'
import {useRecoilState} from 'recoil'
import {InputBase} from "../../common";
import {studioProfileFormState} from "./atoms";


type Props = {
    type: string
    name: string
    label: string
    placeholder: string
    value?: string
    disabled?: boolean
}

const Input: React.FC<Props> = ({type, name, placeholder, label, value,disabled}: Props) => {
    const [state, setState] = useRecoilState(studioProfileFormState)

    return (
        <div className={'label_input_wrapper'}>
            <label style={{color: 'white'}}>
                {label}
            </label>
            <InputBase
                disabled={disabled}
                className={'form_input'}
                type={type}
                name={name}
                placeholder={placeholder}
                state={state}
                setState={setState}
                value={value}
            />
        </div>
    )
}

export default Input
